import { render, staticRenderFns } from "./ExpiredLicenceAlert.vue?vue&type=template&id=7dac2f3a&scoped=true"
import script from "./ExpiredLicenceAlert.vue?vue&type=script&lang=js"
export * from "./ExpiredLicenceAlert.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLicenceAlert.vue?vue&type=style&index=0&id=7dac2f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac2f3a",
  null
  
)

export default component.exports